import React from "react";
import PropTypes from "prop-types";
import AppChrome from "./AppChrome";
import MainFooter from "../components/layout/MainFooter";

const DefaultLayout = ({ children, noNavbar = false, noFooter = false }) => (
  <div className="app-layout-shell">
    <div className="app-layout-main">
      <AppChrome noNavbar={noNavbar}>{children}</AppChrome>
    </div>
    {!noFooter && <MainFooter />}
  </div>
);

DefaultLayout.propTypes = {
  noNavbar: PropTypes.bool,
  noFooter: PropTypes.bool,
};

export default DefaultLayout;
